import { colors } from '../theme';

/** Status is never conveyed by color alone — the dot is always paired with
 * the text label, satisfying the accessibility requirement that status not
 * rely only on color. */
export function StatusDot({ status }: { status: 'Running' | 'Failed' }) {
  const color = status === 'Running' ? colors.success : colors.danger;
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
      <span
        aria-hidden="true"
        style={{
          width: 8,
          height: 8,
          borderRadius: '50%',
          background: color,
          display: 'inline-block',
        }}
      />
      <span style={{ color, fontWeight: 500, fontSize: 13 }}>{status}</span>
    </span>
  );
}
